// helpers/sortHelper.js
import { useState } from "react";

export const sortHelper = {
  // Fungsi untuk mendapatkan nilai dari nested object
  getValueByPath: (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  },

  // Custom hook untuk sorting
  useSort: (initialKey = null, initialDirection = "asc") => {
    const [sortConfig, setSortConfig] = useState({
      key: initialKey,
      direction: initialDirection,
    });

    const handleSort = (key) => {
      setSortConfig((prev) => ({
        key,
        direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
      }));
    };

    const getSortedData = (data) => {
      if (!sortConfig.key || !data) return data;

      return [...data].sort((a, b) => {
        let aValue = sortHelper.getValueByPath(a, sortConfig.key);
        let bValue = sortHelper.getValueByPath(b, sortConfig.key);

        // Handle null values
        if (aValue == null) return 1;
        if (bValue == null) return -1;

        // Handle string comparison
        if (typeof aValue === "string" && typeof bValue === "string") {
          return sortConfig.direction === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        }

        // Handle number and other comparisons
        if (aValue < bValue) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }

        return 0;
      });
    };

    return {
      sortConfig,
      handleSort,
      getSortedData,
    };
  },

  // Komponen SortableHeader
  SortableHeader: ({ label, sortKey, sortConfig, onSort }) => (
    <th onClick={() => onSort(sortKey)} style={{ cursor: "pointer" }} className="sortable-header fw-bold">
      {label}
      {sortConfig.key === sortKey && <span className="ms-1 fw-bold">{sortConfig.direction === "asc" ? "↑" : "↓"}</span>}
    </th>
  ),
};
